const FULL_PLAN_RENDER_REQUEST = Object.freeze({ kind: 'full' });

function samePlanContext(first, second) {
  return first?.project === second?.project
    && first?.sheetId === second?.sheetId
    && first?.view === second?.view;
}

function sameDragContext(first, second) {
  return samePlanContext(first, second)
    && first?.drag === second?.drag
    && first?.dragActive === true
    && second?.dragActive === true
    && first?.dragType === second?.dragType
    && first?.dragOwner === second?.dragOwner
    && first?.dragSystemId === second?.dragSystemId;
}

function createPlanRenderRequest(options = {}, context = {}) {
  const kind = options?.kind;
  if (!context.project || context.view !== 'plan') return FULL_PLAN_RENDER_REQUEST;
  if (kind === 'navigation' || kind === 'annotations') {
    return { kind, context: { ...context } };
  }
  if (kind === 'system-drag'
    && typeof options.systemId === 'string'
    && options.systemId.length > 0
    && context.dragActive === true
    && context.dragSystemId === options.systemId) {
    return { kind, systemId: options.systemId, context: { ...context } };
  }
  return FULL_PLAN_RENDER_REQUEST;
}

function mergePlanRenderRequests(previous, next = FULL_PLAN_RENDER_REQUEST) {
  if (!previous) return next;
  if (previous.kind === 'full' || next.kind === 'full' || previous.kind !== next.kind) {
    return FULL_PLAN_RENDER_REQUEST;
  }
  if (!samePlanContext(previous.context, next.context)) return FULL_PLAN_RENDER_REQUEST;
  if (previous.kind === 'system-drag'
    && (previous.systemId !== next.systemId || !sameDragContext(previous.context, next.context))) {
    return FULL_PLAN_RENDER_REQUEST;
  }
  return previous;
}

function resolvePlanRenderRequest(request, currentContext) {
  if (!request || request.kind === 'full') return FULL_PLAN_RENDER_REQUEST;
  if (!samePlanContext(request.context, currentContext)) return FULL_PLAN_RENDER_REQUEST;
  if (request.kind === 'system-drag' && !sameDragContext(request.context, currentContext)) {
    return FULL_PLAN_RENDER_REQUEST;
  }
  return request;
}

export {
  createPlanRenderRequest,
  mergePlanRenderRequests,
  resolvePlanRenderRequest
};
